import { formatViewInterval } from "~/tools/date-time/format/format-view-interval";
import type { Time } from "~/tools/date-time/time";

export interface FormatTimeParams {
	time: Time;
	timelineStart: Time;
	timelineEnd: Time;
	now: Time;
}

export const formatTime = ({ time, timelineStart, timelineEnd, now }: FormatTimeParams): string =>
	formatViewInterval({
		interval: [timelineStart, timelineEnd],
		now,
		viewTime: timelineEnd,
		alwaysUseSecondsFormat: true,
	}).format(time);
